var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('img',{attrs:{"alt":"tim logo","id":"logo","src":require("../assets/tim.png")}}),_c('Form'),_c('Analytics')],1)}
var staticRenderFns = []

export { render, staticRenderFns }